export default __webpack_public_path__ + "static/img/4.399d3ff.png";